import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, Outlet, useLocation } from "react-router-dom";
import { UserButton } from "@clerk/clerk-react";
const NAV = [
    { to: "/admin", label: "Dashboard" },
    { to: "/admin/menu", label: "Menú" },
    { to: "/admin/categories", label: "Categorías" },
    { to: "/admin/modifiers", label: "Modificadores" },
    { to: "/admin/promos", label: "Promos" },
    { to: "/admin/combos", label: "Combos" },
    { to: "/admin/happy_hour", label: "Happy hour" },
    { to: "/admin/qr", label: "QR mesas" },
    { to: "/admin/floor_plan", label: "Mapa de piso" },
    { to: "/admin/sections", label: "Secciones" },
    { to: "/admin/loyalty", label: "Lealtad" },
    { to: "/admin/customer", label: "Buscar cliente" },
    { to: "/admin/reservations", label: "Reservaciones" },
    { to: "/admin/cost_report", label: "Costos & margen" },
    { to: "/admin/inventory", label: "Inventario" },
    { to: "/admin/stock_history", label: "Mov. inventario" },
    { to: "/admin/waste", label: "Mermas" },
    { to: "/admin/staff", label: "Staff" },
    { to: "/admin/permissions", label: "Permisos" },
    { to: "/admin/gift_cards", label: "Tarjetas regalo" },
    { to: "/admin/broadcasts", label: "Mensajes" },
    { to: "/admin/clock", label: "Time clock" },
    { to: "/admin/performance", label: "Performance" },
    { to: "/admin/tip_pool", label: "Repartición" },
    { to: "/admin/feedback", label: "Feedback" },
    { to: "/admin/audit", label: "Bitácora" },
    { to: "/admin/shrinkage", label: "Mermas (acciones)" },
    { to: "/admin/print_queue", label: "Cola impresión" },
    { to: "/admin/webhooks", label: "Webhooks (in)" },
    { to: "/admin/webhooks_out", label: "Webhooks (out)" },
    { to: "/admin/cash", label: "Caja" },
    { to: "/admin/close", label: "Cierre Z" },
    { to: "/admin/cfdi_pending", label: "Facturas pendientes" },
    { to: "/admin/settings", label: "Configuración" },
];
export default function AdminShell() {
    const loc = useLocation();
    return (_jsxs("div", { className: "pos min-h-screen grid grid-cols-[200px_1fr]", children: [_jsxs("aside", { className: "bg-white border-r border-gray-200 flex flex-col", children: [_jsxs("div", { className: "px-4 py-4 border-b border-gray-200", children: [_jsx("div", { className: "text-[11px] uppercase tracking-wider text-gray-500", children: "Ikali" }), _jsx("div", { className: "text-base font-semibold leading-tight", children: "POS Admin" })] }), _jsx("nav", { className: "flex flex-col gap-px py-2", children: NAV.map((n) => {
                            const active = loc.pathname === n.to || (n.to !== "/admin" && loc.pathname.startsWith(n.to));
                            return (_jsx(Link, { to: n.to, className: `px-4 py-2 text-sm ${active ? "bg-mezcal/10 text-mezcal font-semibold border-l-2 border-mezcal" : "text-gray-700 hover:bg-gray-50 border-l-2 border-transparent"}`, children: n.label }, n.to));
                        }) }), _jsxs("div", { className: "mt-auto px-4 py-3 border-t border-gray-200 flex items-center justify-between", children: [_jsx(UserButton, { afterSignOutUrl: "/" }), _jsx(Link, { to: "/", className: "text-[10px] uppercase tracking-wider text-gray-500 hover:text-gray-900", children: "Kiosko" })] })] }), _jsx("main", { className: "overflow-auto", children: _jsx(Outlet, {}) })] }));
}
